/**
 * Puts the repo's Games section (src/games/catalog.json) into the menu tree.
 * Replaces the top-level node with the same id in place, or appends it.
 * Returns a new array; the input is not changed.
 */
export const withGamesSection = (categories, games) => {
  const index = categories.findIndex((c) => c.id === games.id);
  if (index === -1) return [...categories, games];
  return categories.map((c, i) => (i === index ? games : c));
};
